import type { AppUser } from '@/domain/user'

// One demo user per role (Document 2 §3 / Document 11 §4). orgId is
// preserved on every organization-scoped user, per Document 11 §5.
export const seedUsers: AppUser[] = [
  {
    id: 'user-individual',
    orgId: null,
    displayName: 'Amaka (Individual Learner)',
    email: 'amaka.individual@example.com',
    role: 'individual_learner',
    locale: 'en',
    leaderboardOptOut: false,
    avatarColor: '#22D3EE',
  },
  {
    id: 'user-student',
    orgId: 'org-demo-school',
    teamId: 'dept-jss',
    displayName: 'Tunde (School Student)',
    email: 'tunde.student@demoschool.example',
    role: 'school_student',
    locale: 'en',
    leaderboardOptOut: false,
    avatarColor: '#F2A93B',
  },
  {
    id: 'user-teacher',
    orgId: 'org-demo-school',
    teamId: 'dept-sss',
    displayName: 'Ms. Achieng (Teacher)',
    email: 'achieng.teacher@demoschool.example',
    role: 'teacher',
    locale: 'en',
    leaderboardOptOut: false,
    avatarColor: '#FF6B57',
  },
  {
    id: 'user-employee',
    orgId: 'org-demo-enterprise',
    departmentId: 'dept-ops',
    displayName: 'Kwame (Corporate Employee)',
    email: 'kwame.employee@demoenterprise.example',
    role: 'corporate_employee',
    locale: 'en',
    leaderboardOptOut: false,
    avatarColor: '#67E8F9',
  },
  {
    id: 'user-org-admin',
    orgId: 'org-demo-enterprise',
    departmentId: null,
    displayName: 'Fatima (Org Administrator)',
    email: 'fatima.admin@demoenterprise.example',
    role: 'org_admin',
    locale: 'en',
    leaderboardOptOut: false,
    avatarColor: '#818CF8',
  },
  {
    id: 'user-super-admin',
    orgId: null,
    displayName: 'Zola (Super Administrator)',
    email: 'zola.superadmin@cybertaleslearn.example',
    role: 'super_admin',
    locale: 'en',
    leaderboardOptOut: false,
    avatarColor: '#D98E22',
  },
]
